// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-column-2{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  max-height: 100%;
}

.login-column-1 {
  display: flex;
  flex-direction: column; 
  align-items: center;
  justify-content: center;
  height: 100vh;
  max-height: 100%;
}

.signup {
  display: flex;
  align-items: center;
  height: 100vh;
}

.signup-card {
  font-family: "Inter", sans-serif;
  background-color: white;
  color: black;
  width: 460px;
  display: flex;
  align-items: flex-start; 
  row-gap: 20px;
  flex-direction: column;
}

.signup-width{
  width: 100%;
}
.welcome-head {
 flex-direction: column;
 display: flex;
 justify-content: left;
}

.welcome-head p {
  font-family: "Manjari", serif;
  margin-top: 2px;
  font-size: 28px;
  font-weight: 600;
}

.description {
  font-size: 16px;
  color: #858585;
  font-weight: 600;
  text-align: center;
}

.signup-form {
  margin: 0px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.signup-form p {
  width: 100%;
  float: left;
}

.signup-fields {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 60px;
  background-color: #F5F5F5;
  border: 1px solid #C5C5C5; 
  border-radius: 15px;
  padding: 2px 14px;
  font-size: 14px;
  color: #616161;
  position: relative;
}

.SignUp-button {
  text-align: center;
  width: 100%;
}

.SignUp-button svg {
  font-size: 20px;
  position: absolute;
  left: 70%;
}

.eye {
  position: absolute;
  right: 14px;
  top: 16px;
  cursor: pointer;
}

.forget {
  text-align: right;
  color: #1F61FF;
  cursor: pointer;
}

.signup-fields label {
  margin-bottom: 4px;
  font-size: 10px;
  font-weight: 600;
  color: #616161;
}

.signup-fields svg {
  top: 25px;
  position: absolute;
  right: 20px;
  color: rgb(114, 114, 114);
  font-size: 18px;
}

.signup-fields input {
  background-color: #F5F5F5;
  border: none;
  font-size: 16px;
  color: #212121;
}

input:-internal-autofill-selected {
  border: 0px;
  background-color: #F5F5F5;
  outline: none;
}

.signup-fields input:focus {
  border: 0px;
  background-color: #F5F5F5;
  outline: none;
}

.welcome-head h1 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.SignUp-button button {
  font-size: 18px;
  font-weight: bold;
  color: white;
  background-color: #1B2F48;
  border: none;
  width: 100%;
  height: 60px;
  border-radius: 79px;
  margin-top: 30px;
}

.SignUp-button button:hover{
  background-color: #1f582c;
}
.SignUp-button button p {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Auth/Login.css"],"names":[],"mappings":"AAAA;EACE,yDAAuD;EACvD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;AACA;CACC,sBAAsB;CACtB,aAAa;CACb,qBAAqB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".login-column-2{\n  background-image: url(../../../public/images/login.png);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 100vh;\n  max-height: 100%;\n}\n\n.login-column-1 {\n  display: flex;\n  flex-direction: column; \n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  max-height: 100%;\n}\n\n.signup {\n  display: flex;\n  align-items: center;\n  height: 100vh;\n}\n\n.signup-card {\n  font-family: \"Inter\", sans-serif;\n  background-color: white;\n  color: black;\n  width: 460px;\n  display: flex;\n  align-items: flex-start; \n  row-gap: 20px;\n  flex-direction: column;\n}\n\n.signup-width{\n  width: 100%;\n}\n.welcome-head {\n flex-direction: column;\n display: flex;\n justify-content: left;\n}\n\n.welcome-head p {\n  font-family: \"Manjari\", serif;\n  margin-top: 2px;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.description {\n  font-size: 16px;\n  color: #858585;\n  font-weight: 600;\n  text-align: center;\n}\n\n.signup-form {\n  margin: 0px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.signup-form p {\n  width: 100%;\n  float: left;\n}\n\n.signup-fields {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 60px;\n  background-color: #F5F5F5;\n  border: 1px solid #C5C5C5; \n  border-radius: 15px;\n  padding: 2px 14px;\n  font-size: 14px;\n  color: #616161;\n  position: relative;\n}\n\n.SignUp-button {\n  text-align: center;\n  width: 100%;\n}\n\n.SignUp-button svg {\n  font-size: 20px;\n  position: absolute;\n  left: 70%;\n}\n\n.eye {\n  position: absolute;\n  right: 14px;\n  top: 16px;\n  cursor: pointer;\n}\n\n.forget {\n  text-align: right;\n  color: #1F61FF;\n  cursor: pointer;\n}\n\n.signup-fields label {\n  margin-bottom: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #616161;\n}\n\n.signup-fields svg {\n  top: 25px;\n  position: absolute;\n  right: 20px;\n  color: rgb(114, 114, 114);\n  font-size: 18px;\n}\n\n.signup-fields input {\n  background-color: #F5F5F5;\n  border: none;\n  font-size: 16px;\n  color: #212121;\n}\n\ninput:-internal-autofill-selected {\n  border: 0px;\n  background-color: #F5F5F5;\n  outline: none;\n}\n\n.signup-fields input:focus {\n  border: 0px;\n  background-color: #F5F5F5;\n  outline: none;\n}\n\n.welcome-head h1 {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n}\n\n.SignUp-button button {\n  font-size: 18px;\n  font-weight: bold;\n  color: white;\n  background-color: #1B2F48;\n  border: none;\n  width: 100%;\n  height: 60px;\n  border-radius: 79px;\n  margin-top: 30px;\n}\n\n.SignUp-button button:hover{\n  background-color: #1f582c;\n}\n.SignUp-button button p {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
